import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TicketIcon } from '@razorpay/blade/components';

const RedeemVoucher: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="flex h-[220px] w-[468px] cursor-pointer flex-col items-center justify-center gap-[10px] rounded-3xl bg-white shadow-custom xl:h-[278px]"
      role="button"
      tabIndex={0}
      onClick={() => navigate('/redeem-voucher')}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          navigate('/redeem-voucher');
        }
      }}
    >
      <TicketIcon size="2xlarge" />

      <div className="text-center text-lg font-medium leading-[27px]">
        Redeem Voucher
      </div>
    </div>
  );
};

export default RedeemVoucher;
